export interface NativeMessage {
  type: string;
  [key: string]: any;
}

export type OpenNativeDocumentPayload = {
  type: 'OPEN_DOCUMENT';
  filename: string;
  mimeType: string;
  base64?: string;
  url?: string;
};

export const sendMessageToNative = (message: NativeMessage) => {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify(message));
  }
};

export const blobToBase64 = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result;
      if (typeof result !== 'string') {
        reject(new Error('Failed to read blob'));
        return;
      }
      const comma = result.indexOf(',');
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = () => reject(reader.error ?? new Error('Failed to read blob'));
    reader.readAsDataURL(blob);
  });

/** Opens a document in the native shell (PDF viewer or share sheet for XML). */
export const openNativeDocument = (payload: Omit<OpenNativeDocumentPayload, 'type'>) => {
  if (!isNativeApp()) {
    return false;
  }
  sendMessageToNative({ type: 'OPEN_DOCUMENT', ...payload });
  return true;
};

export const isNativeApp = (): boolean => {
  if (typeof window === 'undefined') return false;

  return !!(
    window.ReactNativeWebView ||
    window.navigator.userAgent.includes('QualiApp Native WebView') ||
    window.QualiAppNative ||
    window.QualiAppNative?.isNativeApp?.()
  );
};

export const openNativeScanner = (): boolean => {
  if (typeof window === 'undefined') return false;

  if (window.QualiAppNative?.openScanner) {
    window.QualiAppNative.openScanner();
    return true;
  } else {
    // Fallback: try to navigate to scanner deep link
    window.location.href = 'qualiappnative://scanner';
    return false;
  }
};
